import { CurrencySettings } from '@ps/user-settings-models';
import { CURRENCY_CODE, CURRENCY_SYMBOLS, Nullable } from '@ps/utils';
import { LocaleToUSDConversion } from './locale-to-usd-conversion';

const PERCENT_BASE = 100;
export const SCPI_CURRENCY_SYMBOL = CURRENCY_SYMBOLS[CURRENCY_CODE.US];

/**
 * SCPI (Supplier CPI) — what the platform pays a supplier once the buyer's
 * target margin is taken off the buyer-facing CPI.
 *
 * SCPI is always quoted in USD regardless of the survey's own currency, so the
 * local result is run through the exchange rate before it is returned. A buyer
 * CPI of 0 (or absent) has no supplier price to derive, hence `null`.
 */
export function supplierCpi(
  buyerCpi: Nullable<number>,
  targetMargin: Nullable<number>,
  currencySettings: Nullable<CurrencySettings>,
): Nullable<number> {
  if (!buyerCpi) {
    return null;
  }

  const localSupplierCpi =
    (buyerCpi * (PERCENT_BASE - (targetMargin ?? 0))) / PERCENT_BASE;

  return new LocaleToUSDConversion(
    localSupplierCpi,
    currencySettings,
  ).convert();
}
